import makeRequest from 'api/makeRequest';
import environment from 'environment';

export const getTroubleshootingAgentAssistResponse = async (data) => {
  const res = await makeRequest(`${environment.services.troubleshootingAgentAssistMLUrl}`, {
    method: 'post',
    data,
  });

  return res;
};

export const getSalesAgentAssistResponse = async (data) => {
  const res = await makeRequest(`${environment.services.salesAgentAssistMLUrl}`, {
    method: 'post',
    data,
  });

  return res;
};
